import PropTypes from 'prop-types';
import { Empty } from 'antd';
import ReadingInstrument from '../Dashboard/components/ReadingInstrument';
import InclinationReading from '../Dashboard/components/InclinationReading';
import '../Dashboard/dashboard.css';

const numeric = value => value == null || String(value).trim() === '' || !Number.isFinite(Number(value)) ? null : Number(value);
// Presentation adapter only: keep unavailable metadata/bounds absent.
function instrumentSensor(sensor) {
    const result = { ...sensor, SensorName: sensor.SensorName || sensor.SensorCode,
        SensorGroup: sensor.SensorGroup || sensor.DisplayGroupName || sensor.SensorName || sensor.SensorCode };
    for (const n of [1, 2, 3]) for (const prefix of ['Value', 'MinValue', 'MaxValue']) result[`${prefix}${n}`] = numeric(sensor[`${prefix}${n}`]);
    return result;
}

export default function SensorDetail({ record, kind }) {
    const sensors = record?.current || [];
    const selected = kind === 'RPM' ? [3, 5].map(number => sensors.find(sensor => sensor.DisplayNo === number))
        : kind === 'Temperature' ? [2, 4].map(number => sensors.find(sensor => sensor.DisplayNo === number))
        : kind === 'Level' ? [sensors.find(sensor => sensor.SensorCode?.startsWith('LVL'))]
        : [sensors.find(sensor => sensor.DisplayNo === 7)];
    const available = selected.filter(Boolean).map(instrumentSensor);
    if (!available.length) return <Empty description="No sensor data available" />;
    return <div className="dashboard-view monitoring-dashboard-instruments">
        <div className={kind === 'Inclination' ? 'dash-inclination-grid' : 'dash-reading-grid'}>
            {available.map(sensor => kind === 'Inclination'
                ? ['Value1', 'Value2'].map(channel => <InclinationReading key={`${sensor.SensorCode}-${channel}`} sensor={sensor} channel={channel} />)
                : <ReadingInstrument key={sensor.SensorCode} sensor={sensor} />)}
        </div>
    </div>;
}
SensorDetail.propTypes = { record: PropTypes.object, kind: PropTypes.string };
